import { Routes, Route } from "react-router-dom";
import NotFound from "./NotFound";
import PrivateRoute from "./PrivateRoute";
import BaseRoute from "./BaseRoute";
import RoleListing from "./pages/roles_and_permission/RoleListing";
import Login from "./pages/auth/Login";
import SignUp from "./pages/auth/SignUp";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import VerifyUser from "./pages/auth/VerifyUser";
import ForgotUsername from "./pages/auth/ForgotUsername";
import ResendVerificationEmail from "./pages/auth/ResendVerificationEmail";
import Dashboard from "./pages/dashboard/Dashboard";
import AssignPermission from "./pages/roles_and_permission/AssignPermission";
import UserListing from "./pages/userManagement/UserListing";
import PublicRoute from "./PublicRoute";
import ConfirmationModal from "./components/ConfirmationModal";
import VendorListing from "./pages/vendor/VendorListing";
import NewVendor from "./pages/vendor/NewVendor";
import CreatePublicRma from "./pages/PublicRMA/CreatePublicRma";
import ContractType from "./pages/contracttype/ContractType";
import NewQuote from "./pages/RFQ/NewQuote";
import OpportunityListing from "./pages/RFQ/OpportunityListing";
import CreateContact from "./pages/customer/CreateContact";
import CreateProduct from "./pages/Product/CreateProduct";
import SkuListing from "./pages/Product/SkuListing";
import EditSku from "./pages/Product/EditSku";
import ContactList from "./pages/customer/ContactList";
import BulkPorduct from "./pages/Product/BulkPorduct";
import CreateLifeCycle from "./pages/lifecycle/CreateLifeCycle";
import LifeCycleListing from "./pages/lifecycle/LifeCycleListing";
import CreateRma from "./pages/RMA/CreateRma";
import CreateProject from "./pages/Project/CreateProject";
import RmaListing from "./pages/RMA/RmaListing";
import ProjectListing from "./pages/Project/ProjectListing";
import LinkCard from "./pages/secureLinkCard/LinkCard";
import { useEffect } from "react";
import ReportBugs from "./pages/bugs/ReportBugs";
import BugsList from "./pages/bugs/BugsList";
import FeedbackForm from "./pages/customerFeedback/FeedbackForm";
import ReviewListing from "./pages/lifecycle/ReviewListing";
import CreateCustomer from "./pages/PublicCustomer/CreateCustomer";
import UpdateRma from "./pages/RMA/UpdateRma";
import CustomerCards from "./pages/customer/CustomerCardslListing";
import CustomerCardsListing from "./pages/customer/CustomerCardslListing";
import FBOPListing from "./pages/FBOP/FBOPListing";
import FBOPForm from "./pages/FBOP/FBOPForm";
import TableListingNew from "./pages/lifecycle/TableListingNew";
import ChangeRequestsBoard from "./pages/ChangeRequests/ChangeRequestsBoard";
import KitPriceChanges from "./pages/Project/KitPriceChanges";
import PackSlipListing from "./pages/lifecycle/PackSlipListing";

const Routing = () => {
  useEffect(() => {
    const setAutoCompleteOff = (inputs) => {
      inputs.forEach((input) => {
        if (input.tagName === "INPUT") {
          input.setAttribute("autocomplete", "off");
        }
      });
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        setAutoCompleteOff(mutation.addedNodes);
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    const allInputs = document.querySelectorAll("input");
    allInputs.forEach((input) => {
      input.setAttribute("autocomplete", "off");
    });

    return () => observer.disconnect();
  }, []);

  return (
    <Routes>
      <Route
        path="/register/customer/:token"
        element={
          <PublicRoute forcePublic={true}>
            <CreateCustomer />
          </PublicRoute>
        }
      />
      <Route
        path="/customer/feedback/:token"
        element={
          <PublicRoute forcePublic={true}>
            <FeedbackForm />
          </PublicRoute>
        }
      />
      <Route
        path="/secure/card/:token"
        element={
          <PublicRoute forcePublic={true}>
            <LinkCard />
          </PublicRoute>
        }
      />
      <Route
        path="/rma"
        element={
          <PublicRoute forcePublic={true}>
            <CreatePublicRma />
          </PublicRoute>
        }
      />
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/register"
        element={
          <PublicRoute>
            <SignUp />
          </PublicRoute>
        }
      />
      <Route
        path="/forgot-password"
        element={
          <PublicRoute>
            <ForgotPassword />
          </PublicRoute>
        }
      />
      <Route
        path="/reset-update-password/:token"
        element={
          <PublicRoute>
            <ResetPassword />
          </PublicRoute>
        }
      />
      <Route
        path="/verify/:token"
        element={
          <PublicRoute>
            <VerifyUser />
          </PublicRoute>
        }
      />
      <Route
        path="/forgot-username"
        element={
          <PublicRoute>
            <ForgotUsername />
          </PublicRoute>
        }
      />
      <Route
        path="/resend-verification-email"
        element={
          <PublicRoute>
            <ResendVerificationEmail />
          </PublicRoute>
        }
      />

      {/* Default route (redirect to login if not logged in) */}
      <Route
        path="/"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />

      {/* Protected routes */}
      <Route
        path="/"
        element={
          <PrivateRoute>
            <BaseRoute />
          </PrivateRoute>
        }
      >
        {/* <Route path="dashboard" element={<Dashboard />} /> */}
        <Route path="report-bug" element={<ReportBugs />} />
        <Route path="list-bugs" element={<BugsList />} />
        <Route path="departments" element={<RoleListing />} />
        <Route path="permissions" element={<AssignPermission />} />
        <Route path="contract-type" element={<ContractType />} />
        <Route path="create-rma" element={<CreateRma />} />
        <Route path="list-rma" element={<RmaListing />} />
        <Route path="change-requests" element={<ChangeRequestsBoard />} />
        <Route
          path="edit-rma/:rma_id"
          element={<CreateRma key={window.location.pathname} />}
        />
        <Route path="/fbop-data/:zip_id" element={<FBOPForm />} />
        <Route path="/list-fbop" element={<FBOPListing />} />
        <Route path="create-rfq" element={<NewQuote />} />
        <Route
          path="edit-rfq/:rfq_id"
          element={<NewQuote key={window.location.pathname} />}
        />
        <Route
          path="copy-quote"
          element={<NewQuote key={window.location.pathname} />}
        />

        <Route path="create-contract-vehicle" element={<CreateProject />} />
        <Route
          path="edit-contract-vehicle/:rfq_id"
          element={<CreateProject key={window.location.pathname} />}
        />
        <Route path="list-contract-vehicles" element={<ProjectListing />} />
        <Route path="list-contract-vehicles-price-changes/:rfqId" element={<KitPriceChanges />} />

        <Route path="create-order-lifecycle" element={<CreateLifeCycle />} />

        <Route
          path="edit-order/:order_id"
          element={<CreateLifeCycle key={window.location.pathname} />}
        />
        <Route
          path="copy-orderlifecycle"
          element={<CreateLifeCycle key={window.location.pathname} />}
        />
        <Route path="list-order-lifecycle" element={<LifeCycleListing />} />
        <Route path="list-customer-reviews" element={<ReviewListing />} />
        <Route path="list-opportunities" element={<OpportunityListing />} />
        <Route path="/pack-slips" element={<PackSlipListing />} />
        <Route path="create-customer" element={<CreateContact />} />
        <Route path="customer-list" element={<ContactList />} />
        <Route path="payment-cards" element={<CustomerCardsListing />} />
        <Route
          path="customer-edit/:auto_id"
          element={<CreateContact key={window.location.pathname} />}
        />
        <Route path="products-list" element={<SkuListing />} />
        <Route
          path="update-product/:sku_id"
          element={<CreateProduct key={window.location.pathname} />}
        />

        <Route path="create-product" element={<CreateProduct />} />
        <Route path="create-bulk-product" element={<BulkPorduct />} />
        <Route path="users" element={<UserListing />} />
        <Route path="vendor" element={<VendorListing />} />
        <Route path="create-vendor" element={<NewVendor />} />
        <Route
          path="edit-vendor/:auto_id"
          element={<NewVendor key={window.location.pathname} />}
        />
        <Route path="/listing-view" element={<TableListingNew/>}/>
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Routing;
